import axios from "axios";
import { host } from "./static";

const api = axios.create({
  baseURL: `${host}/admin-api/v1`,
});

export default api;